<template>
  <div>
    <section class="encabezado encuesta-medicina -padres row-start">
      <img class="logo" src="/img/logo-nuevo.png" alt="Logo UFV Alumni">
    </section>
    <section class="contenedor-encuesta row-between" id="encuesta">
      <h2>Formulario de inscripción</h2>
      <legend>Datos personales</legend>
      <ValidationObserver ref="form" v-slot="{ failed, valid }">
        <form class="row-between fww paso" @submit.prevent="validate" :valid="valid" autocomplete="off">
          <div class="contenedor-input half">
            <ValidationProvider rules="required|min:3" v-slot="{ errors, ariaInput, ariaMsg, classes }">
              <input autocomplete="off" type="text" name="name" placeholder="Nombre*" v-model="data.name"
                :class="classes" />
              <span v-bind="ariaMsg" class="custom-error">{{ errors[0] }}</span>
            </ValidationProvider>
          </div>

          <div class="contenedor-input half">
            <ValidationProvider rules="required|min:3" v-slot="{ errors, ariaInput, ariaMsg, classes }">
              <input autocomplete="off" type="text" name="surname" placeholder="Primer apellido*" v-model="data.surname"
                :class="classes" />
              <span v-bind="ariaMsg" class="custom-error">{{ errors[0] }}</span>
            </ValidationProvider>
          </div>

          <div class="contenedor-input half">
            <ValidationProvider rules="min:3" v-slot="{ errors, ariaInput, ariaMsg, classes }">
              <input autocomplete="off" type="text" name="surname_2" placeholder="Segundo apellido"
                v-model="data.surname_2" :class="classes" />
              <span v-bind="ariaMsg" class="custom-error">{{ errors[0] }}</span>
            </ValidationProvider>
          </div>

          <div class="contenedor-input half">
            <ValidationProvider rules="required|min:9" v-slot="{ errors, ariaInput, ariaMsg, classes }">
              <input autocomplete="off" type="text" name="phone" placeholder="Teléfono/móvil*" v-model="data.phone"
                :class="classes" />
              <span v-bind="ariaMsg" class="custom-error">{{ errors[0] }}</span>
            </ValidationProvider>
          </div>


          <div class="contenedor-input half">
            <ValidationProvider rules="required|email" v-slot="{ errors, ariaInput, ariaMsg, classes }">
              <input autocomplete="off" type="text" name="email" placeholder="Correo electrónico*" :class="classes"
                v-model="data.email" />
              <span v-bind="ariaMsg" class="custom-error">{{ errors[0] }}</span>
            </ValidationProvider>
          </div>
          <div class="contenedor-input half">
            <ValidationProvider rules="required|min:3" v-slot="{ errors, ariaInput, ariaMsg, classes }">
              <input autocomplete="off" type="text" name="address" placeholder="Dirección completa*" :class="classes"
                v-model="data.address" />
              <span v-bind="ariaMsg" class="custom-error">{{ errors[0] }}</span>
            </ValidationProvider>
          </div>



          <legend>Datos académicos</legend>

          <div class="contenedor-input row-start only-one-option no-margin">
            <div class="contenedor-input sinmargen more-options row-start fww ">
              <ValidationProvider rules="required" v-slot="{ errors, ariaInput, ariaMsg, classes }">
                <h5>Soy Egresado de la Escuela de Liderazgo Universitario (ELU)*</h5>
                <div class="mt-10">
                  <input type="radio" :value="true" name="haselu" id="si" v-model="data.study[0].haselu">
                  <label :class="classes" for="si">Sí</label>
                  <input type="radio" :value="false" name="haselu" id="no" v-model="data.study[0].haselu">
                  <label :class="classes" for="no">No</label>
                </div>
                <span v-bind="ariaMsg" class="custom-error" v-if="errors[0]">{{ errors[0] }}</span>
              </ValidationProvider>
            </div>
          </div>

          <div class="contenedor-input mb-0 pb-0" v-if="data.study[0].haselu">
            <p class="msg-info-tel pt-0">Por favor, indica a continuación los datos de la titulación
              <strong><u>que cursabas cuando participaste</u></strong> en la ELU. Si eres egresado/a
              de más de una titulación, podrás incluirla desde tu perfil una vez te hayas registrado.
            </p>
            <div class="grupo-form mt-10">
              <div class="contenedor-input full-width mb-0 ">
                <ValidationProvider rules="required" v-slot="{ errors, ariaInput, ariaMsg, classes }">
                  <autocomplete :key="'autocomplete-study-noufv'" :class="classes" :name="'study'"
                    :label="'Titulación*'" :type="'study_noufv'" v-model="data.study[0].study" :idkey="'id'"
                    @input="setDominioNivel($event)"></autocomplete>
                  <span v-bind="ariaMsg" class="custom-error" v-if="errors[0]">{{ errors[0] }}</span>
                </ValidationProvider>
              </div>
              <div class="contenedor-input full-width pt-0 mb-0">
                <ValidationProvider rules="required" v-slot="{ errors, ariaInput, ariaMsg, classes }">
                  <label for="nivel">Nivel*</label>
                  <select id="nivel" name="nivel" v-model="data.study[0].level" class="pretty" :class="classes">
                    <option name="myBrowser" placeholder="" disabled>
                      <template v-if="data.study[0]['study']">
                        Selecciona*
                      </template>
                      <template v-else>
                        Selecciona una Titulación*
                      </template>
                    </option>
                    <template v-if="data.study[0]['study']">
                      <option :key="key" v-for="(nivel, key) in nivelesFiltered" name="myBrowser" :value="nivel.id">
                        {{ nivel.value }}
                      </option>
                    </template>
                  </select>
                  <span v-bind="ariaMsg" class="custom-error">{{ errors[0] }}</span>
                </ValidationProvider>
              </div>
            </div>
            <div class="grupo-form aifs">
              <div class="contenedor-input full-width pt-0 mb-0">
                <ValidationProvider rules="required" v-slot="{ errors, ariaInput, ariaMsg, classes }">
                  <label for="university">Universidad*</label>
                  <autocomplete :key="'autocomplete-university-noufv'" :formtype="'select'" :class="classes"
                    :name="'university'" :label="'Universidad*'" :type="'university_noufv'"
                    :value="data.study[0].university" :idkey="'id'" @input="setStudyUniversity"></autocomplete>
                  <span v-bind="ariaMsg" class="custom-error" v-if="errors[0]">{{ errors[0] }}</span>
                </ValidationProvider>
              </div>
              <div class="contenedor-input half pt-0 pb-0">
                <ValidationProvider rules="required" v-slot="{ errors, ariaInput, ariaMsg, classes }">
                  <year-datepicker :class="classes" :label="'Año de promoción*'" :minpage="new Date()"
                    v-model="data.study[0].year" :name="'year'"
                    :maxpage="(data.study[0].level == 3 || data.study[0].level == '3') ? new Date('2009-12-31') : null">
                  </year-datepicker>
                  <span v-bind="ariaMsg" class="custom-error" v-if="errors[0]">{{ errors[0] }}</span>
                </ValidationProvider>
              </div>
              <div class="contenedor-input half pb-0">
                <ValidationProvider rules="required" v-slot="{ errors, ariaInput, ariaMsg, classes }">
                  <year-datepicker :class="classes" :label="'Año de promoción ELU*'" :minpage="new Date()"
                    v-model="data.study[0].elu_year" :name="'elu_year'">
                  </year-datepicker>
                  <span v-bind="ariaMsg" class="custom-error" v-if="errors[0]">{{ errors[0] }}</span>
                </ValidationProvider>
                <p class="msg-info-tel pt-0">Es el año en el que finalizaste tus estudios ELU</p>
              </div>
            </div>
          </div>

          <div class="contenedor-input mb-0 pt-0" v-else>
            <p class="msg-info-tel espacio">Por favor, indica a continuación los datos de la titulación
              <strong><u>que has cursado</u></strong> en la UFV. Si eres egresado/a de más de una
              titulación, podrás incluirla desde tu perfil una vez te hayas registrado.
            </p>
            <div class="grupo-form">
              <div class="contenedor-input full-width  pb-0">
                <ValidationProvider rules="required" v-slot="{ errors, ariaInput, ariaMsg, classes }">
                  <autocomplete :key="'autocomplete-study-ufv'" :class="classes" :name="'study'" :label="'Titulación*'"
                    :type="'study_ufv'" v-model="data.study[0].study" :idkey="'id'" @input="setDominioNivel($event)">
                  </autocomplete>
                  <span v-bind="ariaMsg" class="custom-error" v-if="errors[0]">{{ errors[0] }}</span>
                </ValidationProvider>
              </div>
              <div class="contenedor-input full-width pt-0 ">
                <ValidationProvider rules="required" v-slot="{ errors, ariaInput, ariaMsg, classes }">
                  <label for="nivel">Nivel*</label>
                  <select id="nivel" name="nivel" v-model="data.study[0].level" class="pretty " :class="classes">
                    <option name="myBrowser" placeholder="" disabled>
                      <template v-if="data.study[0]['study']">
                        Selecciona*
                      </template>
                      <template v-else>
                        Selecciona una Titulación*
                      </template>
                    </option>
                    <template v-if="data.study[0]['study']">
                      <option :key="key" v-for="(nivel, key) in nivelesFiltered" name="myBrowser" :value="nivel.id">
                        {{ nivel.value }}
                      </option>
                    </template>
                  </select>
                  <span v-bind="ariaMsg" class="custom-error" v-if="errors[0]">{{ errors[0] }}</span>
                  <small v-if="data.study[0].level == 3 || data.study[0].level == '3'" class="small-info">*Para el nivel
                    académico seleccionado, recuerda que el año máximo permitido como año de
                    promoción es 2009</small>
                </ValidationProvider>
              </div>
            </div>
            <div class="grupo-form">
              <div class="contenedor-input half pt-0 pb-0">
                <ValidationProvider rules="required" v-slot="{ errors, ariaInput, ariaMsg, classes }">
                  <label for="university">Universidad*</label>
                  <autocomplete :key="'autocomplete-university-ufv'" :formtype="'select'" :class="classes"
                    :name="'university'" :label="'Universidad*'" :type="'university_ufv'"
                    :value="data.study[0].university" :idkey="'id'" @input="setStudyUniversity"></autocomplete>
                  <span v-bind="ariaMsg" class="custom-error">{{ errors[0] }}</span>
                </ValidationProvider>
              </div>
              <div class="contenedor-input half pb-0">
                <ValidationProvider rules="required" v-slot="{ errors, ariaInput, ariaMsg, classes }">
                  <year-datepicker :class="classes" :label="'Año de promoción*'" :minpage="new Date()"
                    v-model="data.study[0].year" :name="'year'"
                    :maxpage="(data.study[0].level == 3 || data.study[0].level == '3') ? new Date('2009-12-31') : null">
                  </year-datepicker>
                  <span v-bind="ariaMsg" class="custom-error">{{ errors[0] }}</span>
                </ValidationProvider>
              </div>
            </div>
          </div>

          <div class="contenedor-input -check mt-0 ">
            <ValidationProvider rules="required" v-slot="{ errors, ariaInput, ariaMsg, classes }">
              <input type="checkbox" id="id" :class="classes" v-model="data.politica" name="politica" />
              <label for="id" class="mb-0">
                He leído y acepto la
                <a href="https://www.ufv.es/politica-privacidad-alumni" target="_blank">
                  Política de privacidad
                </a>
              </label>
              <span v-bind="ariaMsg" class="custom-error">{{ errors[0] }}</span>
            </ValidationProvider>
          </div>
          <a @click="validate" class="boton-azul" :class="{ loading: loading }">Enviar</a>
        </form>
      </ValidationObserver>

      <div class="form-popup-encuesta" :show="!!dialog">
        <div class="popup" v-if="dialog">
          <h2>{{ dialog.titulo }}</h2>
          <p>{{ dialog.cuerpo }}</p>

          <a v-if="dialog.btnAlumni" href="https://www.alumni-ufv.es/" class="boton-azul">Ir a UFV Alumni</a>
          <a v-else @click="dialog = null" class="boton-azul">Aceptar</a>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import axios from "axios";
import { mapGetters, mapActions } from "vuex";
import 'vue2-datepicker/locale/es/es';


export default {
  name: "formulario-alumni",
  computed: {
    ...mapGetters({
      dominios: "getDominios",
      nivelesFiltered: "getCurrentNiveles",
    }),
    studyHaseluFlag() {
      if (!this.data.study || !this.data.study[0]) {
        return undefined;
      }
      return this.data.study[0].haselu;
    },
  },
  mounted() {
    this.data.event_id = this.$route.query.event_id;
    this.requestStudyAutocomplete();
    document.title = "UFV Alumni";
  },
  data: () => ({
    data: {
      name: "",
      surname: "",
      surname_2: "",
      email: "",
      phone: "",
      address: "",
      event_id: "",
      study: [
        {
          university: null,
          study: null,
          level: "",
          elu_year: "",
          year: "",
          haselu: false,
        },
      ],
    },
    other_bowl: null,
    error: null,
    clicked: false,
    dialog: null,
    loading: false,
  }),
  methods: {
    ...mapActions(["setNiveles", "requestStudyAutocomplete"]),
    validate() {
      this.$refs.form.validate().then((success) => {
        if (success) {
          this.loading = true;

          axios
            .post("/api/auth/register", this.data)
            .then((response) => {
              this.loading = false;
              this.printDialog(response);
              this.$refs.form.reset();
            })
            .catch((response) => {
              this.loading = false;
              this.printDialog(response.response);
            })
        } else {
          const invalidField = this.$refs.form.$children.find((e) => !e.valid)
          if (invalidField)
            invalidField.$el.scrollIntoView({
              behavior: 'smooth',
              block: 'center',
            })
        }
      });
    },
    printDialog(response) {
      if (response == null) {
        this.dialog = {
          titulo: "Error General",
          cuerpo: "Por favor contacte con soporte",
        };
      } else if (response.data && response.data.status) {
        this.dialog = {
          titulo: "¡Enhorabuena!",
          cuerpo: "Te has registrado correctamente.",
          btnAlumni: true,
        };
        this.reset();
      } else if (response.data.messages) {
        this.dialog = {
          titulo: "Error",
          cuerpo: response.data.messages[0].message,
        };
      }
    },
    reset() {
      this.clicked = false;
      this.data = {
        name: "",
        surname: "",
        surname_2: "",
        email: "",
        phone: "",
        address: "",
        event_id: "",
        study: [
          {
            university: null,
            study: null,
            level: "",
            elu_year: "",
            year: "",
            haselu: false,
          },
        ],
      };
    },
    reload() {
      location.reload();
    },
    setDominioNivel(event) {
      this.data.study[0].level = "";
      this.data.study[0].study = event.id;
      this.setNiveles(event.levels);
    },
    setStudyUniversity(option) {
      this.data.study[0].university = option && option.id != null ? option.id : null;
    },
  },
  watch: {
    studyHaseluFlag() {
      if (!this.data.study || !this.data.study[0]) {
        return;
      }
      const s = this.data.study[0];
      s.study = null;
      s.level = "";
      s.year = "";
      s.elu_year = "";
      s.university = null;
      this.setNiveles([]);
    },
  },
};
</script>

<style lang="scss" scoped>
#encuesta * {
  font-family: "Arimo", sans-serif !important;
}

.contenedor-input input[type="checkbox"]+label,
.contenedor-input input[type="radio"]+label {
  width: auto;
  margin-right: 50px;
  margin-bottom: 10px;
}

.contenedor-input input[type="checkbox"],
.contenedor-input input[type="radio"] {
  pointer-events: none;
}

.contenedor-input.-check {
  margin-top: 0px;
  margin-bottom: 0px;
  padding-bottom: 5px;
}

.contenedor-input select {
  width: 100%;
}

.sinmargen {
  padding-bottom: 0px;
}

.no-margin {
  margin-bottom: 0px;
  padding-bottom: 0px;
  padding-top: 0px;

  .contenedor-input {
    margin-bottom: 0px;
  }
}

.responsive {
  display: none;
}

.paso input {
  padding-left: 0 !important;
}

@media screen and (max-width: 895px) {
  .responsive {
    display: block;
  }

  .pc {
    display: none;
  }
}
</style>
